import React from "react";
import { Link } from "react-router-dom";

import { Phone, p } from "../components/ready/PhoneNumber";

import logo from "../images/logo_dark.svg";
import logo_mobile from "../images/logo_dark.svg";
import logo_navbar from "../images/logo_dark.svg";
import Proposal from "../components/blocks/Proposal";

class Item extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      className: this.props.children ? "nav-item dropdown" : "nav-item",
      currentclassName: this.props.children ? "nav-item dropdown" : "nav-item",
      opened: false,
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (window.innerWidth < 1000) {
      if (this.state.currentclassName === this.state.className) {
        this.setState({ currentclassName: this.state.className + " active" });
      } else {
        this.setState({ currentclassName: this.state.className });
      }

      this.setState({ opened: !this.state.opened });
    }
  }
  render() {
    return (
      <li className={this.state.currentclassName}>
        {this.props.children ? (
          <a
            href={this.props.href}
            className={
              this.props.isHeader ? "nav-link nav-link-header " : "nav-link"
            }
            style={this.props.style}
            onClick={this.onClick}
          >
            {this.props.image && (
              <img
                src={this.props.image}
                width={22}
                className={"align-middle"}
                alt={this.props.title}
              />
            )}{" "}
            {this.props.title}
          </a>
        ) : (
          <Link
            onClick={this.props.closeNavbar}
            className="nav-link"
            to="/contact-us"
          >
            Contact Us
          </Link>
        )}

        {this.props.children}
        {this.props.children ? (
          <span onClick={this.onClick} className="navbar-arrow"></span>
        ) : null}
      </li>
    );
  }
}

class Navbar extends React.PureComponent {
  constructor(props) {
    super(props);

    if (window.innerWidth < 1000) {
      this.state = {
        style: {
          left: "-100%",
        },
        showOfferModal: false,
      };
    } else {
      this.state = {
        style: {
          display: "none",
        },
      };
    }

    this.closeNavbar = this.closeNavbar.bind(this);
    this.hideModal = this.hideModal.bind(this);

    this.collapse = this.collapse.bind(this);
  }
  hideModal() {
    this.setState({ showOfferModal: false });
  }
  closeNavbar() {
    if (window.innerWidth < 1000) {
      document.querySelector("body").style.overflowX = "hidden";
      document.querySelector("body").style.overflowY = "auto";
      document.querySelector("body").style.WebkitOverflowScrolling = "auto";

      this.setState({
        style: { left: "-100%" },
      });
    }
  }

  collapse() {
    if (window.innerWidth < 1000) {
      document.querySelector("body").style.overflow = "hidden";
      document.querySelector("body").style.WebkitOverflowScrolling = "touch";

      this.setState((prevState) => ({
        style: { left: prevState.style.left === "-100%" ? "0%" : "-100%" },
      }));
    } else {
      this.setState((prevState) => ({
        style: {
          display: prevState.style.display === "none" ? "block" : "none",
        },
      }));
    }
  }

  render() {
    // var phone_number = <Phone continent={this.props.continent} country={this.props.country}></Phone>;
    return (
      <>
        <div className="container">
          <nav className="navbar navbar-light navbar-expand-lg">
            <a href="/" className="navbar-brand">
              {window.innerWidth < 1000 ? (
                <img
                  src={logo_mobile}
                  alt="weprodigi logo"
                  height={35}
                  width={96}
                ></img>
              ) : (
                <img
                  src={logo}
                  alt="weprodigi logo"
                  height={46}
                  width={104}
                ></img>
              )}
            </a>

            {/* <Link className="navbar-brand" to="/"></Link> */}

            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#collapsibleNavbar"
              onClick={this.collapse}
            >
              <span className="navbar-toggler-icon">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>

            <div
              className="collapse h-full navbar-collapse d-none d-md-flex"
              id="collapsibleNavbar"
              style={this.state.style}
            >
              <div className="h-full collapse-wrapper">
                {window.innerWidth < 1000 ? (
                  <div
                    onClick={this.closeNavbar}
                    className="mobile-navbar-wrapper"
                  >
                    <div className="transparent-part"></div>
                    <div className="navbar-title">Menu</div>

                    <span
                      className="close-button d-md-none"
                      onClick={this.closeNavbar}
                    ></span>
                  </div>
                ) : null}
                <ul className="navbar-nav ml-auto h-full">
                  <li className="navbar-item">
                    <div className="relative">
                      <div
                        className={
                          "header-nav-item h-80 flex items-center cursor-pointer    px-20 font-bolder text-16 text-gray-headerIcon  uppercase"
                        }
                      >
                        <span className={"text-black mr-10"}>Services</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={15}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                        <div className="absolute top-80 -left-10 bg-red-header w-auto min-w-520 p-24 hidden expended-nav-item">
                          <div className={"flex"}>
                            <div className="bg-red-headerInner p-24 w-260 h-220">
                              <div className={"flex items-center"}>
                                <img
                                  src="https://admin.weprodigi.com/uploads/images/header/servises.svg"
                                  width={28}
                                  alt="servises"
                                />
                                <span className={"ml-10 text-black"}>
                                  Production
                                </span>
                              </div>
                              <div className="items mt-10">
                                <a
                                  href="https://weprodigi.com/video-production"
                                  className={
                                    " text-16 link-item font-normal capitalize flex"
                                  }
                                >
                                  <span className={"mr-10"}>
                                    Video Production
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={14}
                                    className={"link-item-svg"}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                                <a
                                  href="https://weprodigi.com/design"
                                  className={
                                    " text-16 link-item font-normal capitalize flex"
                                  }
                                >
                                  <span className={"mr-10"}>
                                    Design Services
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={14}
                                    className={"link-item-svg"}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                                <a
                                  href="/social-media-fun"
                                  className={
                                    " text-16 link-item font-normal capitalize flex"
                                  }
                                >
                                  <span className={"mr-10"}>Game Creation</span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={14}
                                    className={"link-item-svg"}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                                <a
                                  href="/digital-ad-banners"
                                  className={
                                    "text-16 link-item font-normal capitalize flex"
                                  }
                                >
                                  <span className={"mr-10"}>
                                    Banner Production
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={14}
                                    className={"link-item-svg"}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </div>
                            <div className="bg-red-headerInner p-24 w-296 h-220 ml-24">
                              <a
                                href={
                                  "https://weprodigi.com/social-media-marketing"
                                }
                                className={"flex font-bolder items-center"}
                              >
                                <img
                                  src="https://admin.weprodigi.com/uploads/images/header/digital.svg"
                                  width={28}
                                  alt="digital"
                                />
                                <span className={"ml-10 text-16 text-black"}>
                                  Social{" "}
                                </span>
                              </a>
                              <div className="items mt-10">
                                <a
                                  href="https://weprodigi.com/social-media-marketing"
                                  className={
                                    " text-16 link-item font-normal capitalize flex"
                                  }
                                >
                                  <span className={"mr-10"}>
                                    Social Media Management
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={14}
                                    className={"link-item-svg"}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                                <a
                                  href="https://weprodigi.com/facebook-marketing-services"
                                  className={
                                    " text-16 link-item font-normal capitalize flex"
                                  }
                                >
                                  <span className={"mr-10"}>
                                    Facebook Marketing
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={14}
                                    className={"link-item-svg"}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                                <a
                                  href="https://weprodigi.com/instagram-marketing-services"
                                  className={
                                    " text-16 link-item font-normal capitalize flex"
                                  }
                                >
                                  <span className={"mr-10"}>
                                    Instagram Marketing
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={14}
                                    className={"link-item-svg"}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                                <a
                                  href="https://weprodigi.com/linkedin-marketing-services"
                                  className={
                                    " text-16 link-item font-normal capitalize flex"
                                  }
                                >
                                  <span className={"mr-10"}>
                                    Linkedin Marketing
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={14}
                                    className={"link-item-svg"}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                                <a
                                  href="https://weprodigi.com/x-marketing-services"
                                  className={
                                    " text-16 link-item font-normal capitalize flex"
                                  }
                                >
                                  <span className={"mr-10"}>X Marketing</span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={14}
                                    className={"link-item-svg"}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                                <a
                                  href="https://weprodigi.com/snapchat-marketing-services"
                                  className={
                                    " text-16 link-item font-normal capitalize flex"
                                  }
                                >
                                  <span className={"mr-10"}>
                                    Snapchat Marketing
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={14}
                                    className={"link-item-svg"}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </div>
                            <div className="bg-red-headerInner p-24 w-296 h-220 ml-24">
                              <div className={"flex items-center"}>
                                <img
                                  src="https://admin.weprodigi.com/uploads/images/header/digital-marketing.svg"
                                  width={28}
                                  alt="digital marketing"
                                />
                                <span className={"ml-10 text-black"}>
                                  Digital Marketing
                                </span>
                              </div>
                              <div className="items mt-10">
                                <a
                                  href="https://weprodigi.com/main/paid-advertising-services"
                                  className={
                                    " text-16 link-item font-normal capitalize flex"
                                  }
                                >
                                  <span className={"mr-10"}>
                                    Paid Advertising Services
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={14}
                                    className={"link-item-svg"}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                                <a
                                  href="https://weprodigi.com/main/messenger-chatbots-and-stickers"
                                  className={
                                    " text-16 link-item font-normal capitalize flex"
                                  }
                                >
                                  <span className={"mr-10"}>
                                    Messenger Chatbots{" "}
                                  </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={14}
                                    className={"link-item-svg"}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="bg-gray-light h-full mb-2">
                    <div className="relative">
                      <div
                        className={
                          "header-nav-item h-80 flex items-center cursor-pointer  hover:bg-red-header px-20 font-bolder text-16 text-gray-headerIcon hover:text-purple uppercase"
                        }
                      >
                        <span className={"text-black mr-10"}>Clients</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={15}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                        <div className="absolute top-80 left-0 bg-red-header w-230 p-20 hidden expended-nav-item">
                          <a
                            href="/cases"
                            className={
                              " text-16 link-item font-normal capitalize flex"
                            }
                          >
                            <span className={"mr-10"}>Cases</span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={14}
                              className={"link-item-svg"}
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </a>
                          <a
                            href="https://weprodigi.com/testimonals"
                            className={
                              " text-16 link-item font-normal capitalize flex"
                            }
                          >
                            <span className={"mr-10"}>Testimonials</span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={14}
                              className={"link-item-svg"}
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </a>
                          <a
                            href="https://weprodigi.com/industries"
                            className={
                              " text-16 link-item font-normal capitalize flex"
                            }
                          >
                            <span className={"mr-10"}>Industries</span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={14}
                              className={"link-item-svg"}
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="bg-gray-light h-full ">
                    <div className="relative">
                      <div
                        className={
                          "header-nav-item h-80 flex items-center cursor-pointer  hover:bg-red-header px-20 font-bolder text-16 text-gray-headerIcon hover:text-purple uppercase"
                        }
                      >
                        <span
                          className={"text-black mr-10 whitespace-nowrap"}
                          style={{ whiteSpace: "nowrap" }}
                        >
                          About Us
                        </span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={15}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                        <div className="absolute top-80 left-0 bg-red-header w-230 p-20 hidden expended-nav-item">
                          <a
                            href="https://weprodigi.com/contact-us"
                            className={
                              " text-16 link-item font-normal capitalize flex"
                            }
                          >
                            <span
                              className={"mr-10 whitespace-nowrap"}
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Contact Us
                            </span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={14}
                              className={"link-item-svg"}
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </a>
                          <a
                            href="https://weprodigi.com/about-us"
                            className={
                              " text-16 link-item font-normal capitalize flex"
                            }
                          >
                            <span className={"mr-10"}>About Company</span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={14}
                              className={"link-item-svg"}
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </a>
                          {this.props.country !== "AM" && (
                            <a
                              href="https://weprodigi.com/team"
                              className={
                                " text-16 link-item font-normal capitalize flex"
                              }
                            >
                              <span className={"mr-10"}>Team</span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={14}
                                className={"link-item-svg"}
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </li>

                  <li className="bg-gray-light h-full mb-2">
                    <div className="relative">
                      <a
                        href={"https://weprodigi.com/contact-us"}
                        className={
                          "header-nav-item text-decoration-none h-80 flex items-center cursor-pointer  hover:bg-red-header px-20 font-bolder text-16 text-gray-headerIcon hover:text-purple uppercase"
                        }
                      >
                        <span className={"text-black mr-10"}>Contact Us</span>
                      </a>
                    </div>
                  </li>
                  <li className="bg-gray-light h-full mb-2">
                    <div className="relative">
                      <div
                        className={
                          "header-nav-item h-80 flex items-center cursor-pointer  hover:bg-red-header px-20 font-bolder text-16 text-gray-headerIcon hover:text-purple uppercase"
                        }
                      >
                        <span className={"text-black mr-10"}>Resources</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={15}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth={2}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                        <div className="absolute top-80 -right-100 bg-red-header w-auto  p-24 hidden expended-nav-item">
                          <div className={"flex"}>
                            <div className="bg-red-headerInner p-24 w-296 h-full ">
                              <div className={"flex items-center"}>
                                <img
                                  src="https://admin.weprodigi.com/uploads/images/header/location.svg"
                                  width={35}
                                  alt="location"
                                />
                                <span className={"ml-10 text-black"}>
                                  Locations
                                </span>
                              </div>
                              <div className="items mt-10">
                                <a
                                  href="https://weprodigi.com/services/digital-marketing-services-in-saudi"
                                  className={
                                    " text-16 link-item font-normal capitalize flex"
                                  }
                                >
                                  <span className={"mr-10"}>Saudi Arabia</span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={14}
                                    className={"link-item-svg"}
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                              </div>
                              <div className={"flex items-center mt-10"}>
                                <img
                                  src="https://admin.weprodigi.com/uploads/images/header/video.svg"
                                  width={35}
                                  alt="video"
                                />
                                <span className={"ml-10 text-black"}>
                                  Video Production
                                </span>
                              </div>
                              <div className="items mt-10">
                                <div className="relative nav-item">
                                  <div className=" py-10 text-16 link-item font-medium capitalize flex">
                                    <span className={"mr-10"}>Industries</span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={14}
                                      className={"link-item-svg"}
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M19 9l-7 7-7-7"
                                      />
                                    </svg>
                                  </div>

                                  <div className="h-0 pl-10 nav-item-hidden font-normal text-14 overflow-hidden">
                                    <a
                                      href="https://weprodigi.com/healthcare"
                                      className={
                                        " text-14 link-item font-normal capitalize flex"
                                      }
                                    >
                                      <span className={"mr-10"}>
                                        Healthcare Video
                                      </span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={14}
                                        className={"link-item-svg"}
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                    <a
                                      href="https://weprodigi.com/financial"
                                      className={
                                        " text-14 link-item font-normal capitalize flex"
                                      }
                                    >
                                      <span className={"mr-10"}>
                                        Financial Video
                                      </span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={14}
                                        className={"link-item-svg"}
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                    <a
                                      href="https://weprodigi.com/main/startup"
                                      className={
                                        " text-14 link-item font-normal capitalize flex"
                                      }
                                    >
                                      <span className={"mr-10"}>
                                        Startup Video
                                      </span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={14}
                                        className={"link-item-svg"}
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                    <a
                                      href="https://weprodigi.com/SAAS-videos"
                                      className={
                                        " text-14 link-item font-normal capitalize flex"
                                      }
                                    >
                                      <span className={"mr-10"}>
                                        SAAS video
                                      </span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={14}
                                        className={"link-item-svg"}
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                  </div>
                                </div>
                                <div className="relative nav-item">
                                  <div className=" py-10 text-16 link-item font-medium capitalize flex">
                                    <span className={"mr-10"}>
                                      Video Styles
                                    </span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={14}
                                      className={"link-item-svg"}
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M19 9l-7 7-7-7"
                                      />
                                    </svg>
                                  </div>

                                  <div className="h-0 pl-10 nav-item-hidden font-normal text-14 overflow-hidden">
                                    <a
                                      href="https://weprodigi.com/main/2d-animation"
                                      className={
                                        " text-14 link-item font-normal capitalize flex"
                                      }
                                    >
                                      <span className={"mr-10"}>
                                        2D Animation
                                      </span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={14}
                                        className={"link-item-svg"}
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                    <a
                                      href="https://weprodigi.com/main/3d-animation"
                                      className={
                                        " text-14 link-item font-normal capitalize flex"
                                      }
                                    >
                                      <span className={"mr-10"}>
                                        3D Animation
                                      </span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={14}
                                        className={"link-item-svg"}
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                    <a
                                      href="https://weprodigi.com/main/whiteboard-animation"
                                      className={
                                        " text-14 link-item font-normal capitalize flex"
                                      }
                                    >
                                      <span className={"mr-10"}>
                                        Whiteboard Animation
                                      </span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={14}
                                        className={"link-item-svg"}
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                  </div>
                                </div>
                                <div className="relative nav-item">
                                  <div className=" py-10 text-16 link-item font-medium capitalize flex">
                                    <span className={"mr-10"}>Video Types</span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={14}
                                      className={"link-item-svg"}
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M19 9l-7 7-7-7"
                                      />
                                    </svg>
                                  </div>

                                  <div className="h-0 pl-10 nav-item-hidden font-normal text-14 overflow-hidden">
                                    <a
                                      href="https://weprodigi.com/main/explainer-videos"
                                      className={
                                        " text-14 link-item font-normal capitalize flex"
                                      }
                                    >
                                      <span className={"mr-10"}>
                                        Explainer Video
                                      </span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={14}
                                        className={"link-item-svg"}
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                    <a
                                      href="https://weprodigi.com/main/social-media-videos"
                                      className={
                                        "text-14 link-item font-normal capitalize flex"
                                      }
                                    >
                                      <span className={"mr-10"}>
                                        Social Media Videos
                                      </span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={14}
                                        className={"link-item-svg"}
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                    <a
                                      href="https://weprodigi.com/main/commercial-videos"
                                      className={
                                        " text-14 link-item font-normal capitalize flex"
                                      }
                                    >
                                      <span className={"mr-10"}>
                                        Commercial Video
                                      </span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={14}
                                        className={"link-item-svg"}
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                    <a
                                      href="https://weprodigi.com/main/product-videos"
                                      className={
                                        " text-14 link-item font-normal capitalize flex"
                                      }
                                    >
                                      <span className={"mr-10"}>
                                        Product Video
                                      </span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={14}
                                        className={"link-item-svg"}
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                    <a
                                      href="https://weprodigi.com/main/software-feauture-videos"
                                      className={
                                        " text-14 link-item font-normal capitalize flex"
                                      }
                                    >
                                      <span className={"mr-10"}>
                                        Software Video
                                      </span>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={14}
                                        className={"link-item-svg"}
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="row align-items-center">
                    <style jsx global>{`
                      .align-middle {
                        vertical-align: middle;
                      }
                      .type1 {
                        position: relative;
                        padding: 14px 2px;
                        border: none;
                        background-color: transparent;
                        cursor: pointer;
                        outline: none;
                        margin: 0 23px;
                        font-weight: normal;
                        font-size: 15px;
                        line-height: 2px;
                        background: #09af77;
                        color: white;
                        border-radius: 5px;
                      }

                      .button-arrow {
                        visibility: hidden;
                      }

                      .span-width-animation-parent:hover .button-arrow {
                        -webkit-animation: rightAnimation 0.3s linear;
                        -webkit-animation-fill-mode: forwards;
                        animation-delay: 0.1s;
                      }
                      @-webkit-keyframes widthAnimation {
                        0% {
                          width: 80%;
                        }
                        100% {
                          width: 100%;
                        }
                      }
                      @-webkit-keyframes rightAnimation {
                        0% {
                          right: 17px;
                          visibility: visible;
                        }
                        100% {
                          right: 10px;
                          visibility: visible;
                        }
                      }
                      .span-width-animation-parent {
                        position: relative;
                        width: 180px;
                      }
                      .span-width-animation {
                        position: absolute;
                        left: 0;
                        top: 0;
                        display: block;
                        background: #09af77;
                        width: 0;
                        text-align: center;
                        height: 30px;
                      }
                      .second {
                        position: absolute;
                        left: 0;
                        top: 0;
                        display: block;
                        background: #09af77;
                        color: white;
                        border-radius: 5px;
                        text-align: center;
                        height: 30px;
                        width: 180px;
                        opacity: 0;
                        line-height: 30px;
                      }
                      . h-6 {
                        height: 10px;
                      }
                      .w-6 {
                        width: 20px;
                      }
                      .button-arrow {
                        position: absolute;
                        display: inline-block;
                        right: 360px;
                        top: 5px;
                      }
                    `}</style>
                    <button
                      className="span-width-animation-parent relative button type1  w-180"
                      onClick={() => {
                        this.setState({ showOfferModal: true });
                      }}
                    >
                      Get a Proposal
                      <span
                        className="span-width-animation    absolute w-0 h-30"
                        onClick={() => {
                          this.setState({ showOfferModal: true });
                        }}
                      >
                        {" "}
                      </span>
                      <span className="second left-0 top-0 block  text-white text-black absolute w-180 leading-30 h-30 opacity-0">
                        {" "}
                        Get a Proposal
                      </span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="absolute right-30 top-3px  h-6 w-6 inline-block button-arrow"
                        viewBox="0 0 20 20"
                        fill="#ffffff"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </li>
                </ul>
                {window.innerWidth < 1000 ? (
                  <div className="navbar-footer">
                    <p>
                      {" "}
                      <a href={"tel:" + p}>
                        <span className="icon-phone"></span>{" "}
                        <Phone
                          continent={this.props.continent}
                          country={this.props.country}
                        ></Phone>
                      </a>{" "}
                    </p>

                    <ul className="list-inline social-icons-wrap">
                      <li className="list-inline-item">
                        <a
                          className="social-icon"
                          href="https://www.facebook.com/weprodigi/"
                        >
                          <span className="facebook"></span>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a
                          className="social-icon"
                          href="https://www.instagram.com/weprodigi_agency/"
                        >
                          <span className="instagram"></span>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a
                          className="social-icon"
                          href="https://www.linkedin.com/company/weprodigiagency/"
                        >
                          <span className="linkedin"></span>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a
                          className="social-icon"
                          href="https://www.youtube.com/channel/UC6mkepDFKswxQWS76hgOMBg"
                        >
                          <span className="youtube"></span>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a
                          className="social-icon"
                          href="https://x.com/WeProdigi"
                        >
                          <span className="x"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                ) : null}
              </div>
            </div>

            {/* Mobile menu start */}

            <div
              className="collapse navbar-collapse d-md-none"
              id="collapsibleNavbar"
              style={this.state.style}
            >
              <div className="collapse-wrapper">
                <div
                  onClick={this.closeNavbar}
                  className="mobile-navbar-wrapper"
                >
                  <div className="transparent-part"></div>
                  <div className="navbar-title">
                    <img src={logo_navbar} alt="Logo" width={90} height={35} />

                    <span
                      className="close-button d-md-none"
                      onClick={this.closeNavbar}
                    ></span>
                  </div>
                </div>

                <p
                  style={{
                    color: "#670F7A",
                    fontSize: "18px",
                    fontWeight: "500",
                    textTransform: "uppercase",
                    marginTop: "5px",
                    marginBottom: "5px",
                  }}
                >
                  Services
                </p>

                <ul className="navbar-nav ml-auto">
                  <Item
                    title="Production"
                    href="#"
                    image={
                      "https://admin.weprodigi.com/uploads/images/header/servises.svg"
                    }
                  >
                    <div className="dropdown-menu">
                      <a
                        className="dropdown-item"
                        href="https://weprodigi.com/video-production"
                      >
                        Video Production
                      </a>
                      <a
                        className="dropdown-item"
                        href="https://weprodigi.com/design"
                      >
                        Design Services
                      </a>
                      <Link
                        onClick={this.closeNavbar}
                        className="dropdown-item"
                        to="/social-media-fun"
                      >
                        Game Creation
                      </Link>
                      <Link
                        onClick={this.closeNavbar}
                        className="dropdown-item"
                        to="/digital-ad-banners"
                      >
                        Banner Production
                      </Link>
                    </div>
                  </Item>
                  <Item
                    title="Social"
                    href="#"
                    image={
                      "https://weprodigi.com/uploads/images/header/digital.svg"
                    }
                  >
                    <div className="dropdown-menu">
                      <a
                        className="dropdown-item"
                        href="https://weprodigi.com/social-media-marketing"
                      >
                        Social Media Marketing
                      </a>
                      <a
                        className="dropdown-item"
                        href="https://weprodigi.com/facebook-marketing-services"
                      >
                        Facebook Marketing
                      </a>
                      <a
                        className="dropdown-item"
                        href="https://weprodigi.com/instagram-marketing-services"
                      >
                        Instagram Marketing
                      </a>
                      <a
                        className="dropdown-item"
                        href="https://weprodigi.com/linkedin-marketing-services"
                      >
                        Linkedin Marketing
                      </a>
                      <a
                        className="dropdown-item"
                        href="https://weprodigi.com/xr-marketing-services"
                      >
                        X Marketing
                      </a>
                      <a
                        className="dropdown-item"
                        href="https://weprodigi.com/snapchat-marketing-services"
                      >
                        Snapchat Marketing
                      </a>
                    </div>
                  </Item>
                  <Item
                    title="Digital Marketing"
                    href="#"
                    image={
                      "https://weprodigi.com/uploads/images/header/digital-marketing.svg"
                    }
                  >
                    <div className="dropdown-menu">
                      <a
                        className="dropdown-item"
                        href="https://weprodigi.com/paid-advertising-services"
                      >
                        Paid Advertising Services
                      </a>
                      <Link
                        onClick={this.closeNavbar}
                        className="dropdown-item"
                        to="https://weprodigi.com/main/messenger-chatbots-and-stickers"
                      >
                        Messenger Chatbots{" "}
                      </Link>
                    </div>
                  </Item>
                  <p
                    style={{
                      color: "#670F7A",
                      fontSize: "18px",
                      fontWeight: "500",
                      textTransform: "uppercase",
                      marginTop: "5px",
                      marginBottom: "5px",
                    }}
                  >
                    About
                  </p>

                  <Item title="ProDigi" href="#">
                    <div className="dropdown-menu">
                      <a
                        className="dropdown-item"
                        href="https://weprodigi.com/contact-us"
                      >
                        Contact Us
                      </a>
                      <a
                        className="dropdown-item"
                        href="https://weprodigi.com/about-us"
                      >
                        About Company
                      </a>
                      {this.props.country !== "AM" && (
                        <a
                          className="dropdown-item"
                          href="https://weprodigi.com/team"
                        >
                          Team
                        </a>
                      )}
                    </div>
                  </Item>

                  <Item title="Clients" href="#">
                    <div className="dropdown-menu">
                      <Link
                        onClick={this.closeNavbar}
                        className="dropdown-item"
                        to="/cases"
                      >
                        Cases
                      </Link>
                      <a
                        className="dropdown-item"
                        href="https://weprodigi.com/testimonals"
                      >
                        Testimonials
                      </a>
                      <a
                        className="dropdown-item"
                        href="https://weprodigi.com/industries"
                      >
                        Industries
                      </a>
                    </div>
                  </Item>
                  <a
                    href="https://weprodigi.com/blog"
                    style={{
                      color: "#670F7A",
                      fontSize: "18px",
                      fontWeight: "500",
                      textTransform: "uppercase",
                      marginTop: "2px",
                      marginBottom: "5px",
                      textDecoration: "none",
                    }}
                  >
                    Blog
                  </a>

                  <Item title="Resources" href="#" isHeader={true}>
                    <div className="dropdown-menu">
                      <Item
                        title="Location"
                        href="#"
                        image={
                          "https://admin.weprodigi.com/uploads/images/header/location.svg"
                        }
                      >
                        <div className="dropdown-menu">
                          <a
                            className="dropdown-item"
                            href="https://weprodigi.com/services/digital-marketing-services-in-saudi"
                          >
                            Saudi Arabia
                          </a>
                        </div>
                      </Item>

                      <Item
                        title="Video Production"
                        href="#"
                        image={
                          "https://admin.weprodigi.com/uploads/images/header/video.svg"
                        }
                      >
                        <div className="dropdown-menu">
                          <Item title="Industries" href="#">
                            <div className="dropdown-menu">
                              <Link
                                onClick={this.closeNavbar}
                                className="dropdown-item"
                                to="/healthcare"
                              >
                                Healthcare Video
                              </Link>
                              <Link
                                onClick={this.closeNavbar}
                                className="dropdown-item"
                                to="/financial"
                              >
                                Financial Video
                              </Link>
                              <Link
                                onClick={this.closeNavbar}
                                className="dropdown-item"
                                to="/main/startup"
                              >
                                Startup Video
                              </Link>
                              <Link
                                onClick={this.closeNavbar}
                                className="dropdown-item"
                                to="/SAAS-videos"
                              >
                                SAAS video
                              </Link>
                            </div>
                          </Item>
                          <Item title="Video Styles" href="#">
                            <div className="dropdown-menu">
                              <Link
                                onClick={this.closeNavbar}
                                className="dropdown-item"
                              >
                                2D Animation
                              </Link>
                              <Link
                                onClick={this.closeNavbar}
                                className="dropdown-item"
                              >
                                3D Animation
                              </Link>
                              <Link
                                onClick={this.closeNavbar}
                                className="dropdown-item"
                              >
                                Whiteboard Animation
                              </Link>
                            </div>
                          </Item>
                          <Item title="Video Types" href="#">
                            <div className="dropdown-menu">
                              <Link
                                onClick={this.closeNavbar}
                                className="dropdown-item"
                              >
                                Explainer Video
                              </Link>
                              <Link
                                onClick={this.closeNavbar}
                                className="dropdown-item"
                              >
                                Social Media Videos
                              </Link>
                              <Link
                                onClick={this.closeNavbar}
                                className="dropdown-item"
                              >
                                Commercial Video
                              </Link>
                              <Link
                                onClick={this.closeNavbar}
                                className="dropdown-item"
                              >
                                Product Video
                              </Link>
                              <Link
                                onClick={this.closeNavbar}
                                className="dropdown-item"
                              >
                                Software Video
                              </Link>
                            </div>
                          </Item>
                        </div>
                      </Item>
                    </div>
                  </Item>
                  {window.innerWidth > 1000 ? (
                    <li className="nav-item">
                      <span className="nav-link">
                        <p className="nav-contacts">
                          <span className="icon-phone"></span>{" "}
                          <Phone
                            continent={this.props.continent}
                            country={this.props.country}
                          ></Phone>
                        </p>
                      </span>
                    </li>
                  ) : null}
                </ul>
                {window.innerWidth < 1000 ? (
                  <div className="navbar-footer">
                    <p class="value-time">We Value your time</p>
                    <div className={"flex justify-center"}>
                      <a
                        href="/video-production/get-pricing"
                        rel="noreferrer"
                        area-label={"links"}
                        target="_blank"
                        className="schedule mr-5m"
                      >
                        Get Pricing
                      </a>
                      <a
                        href="https://calendly.com/info-weprodigi/call-with-account-team-digital-marketing"
                        rel="noreferrer"
                        area-label={"links"}
                        target="_blank"
                        className="ml-5m schedule"
                      >
                        Schedule a call
                      </a>
                    </div>
                    <ul className="list-inline social-icons-wrap">
                      <li className="list-inline-item">
                        <a
                          className="social-icon"
                          href="https://www.facebook.com/weprodigi/"
                        >
                          <span className="facebook"></span>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a
                          className="social-icon"
                          href="https://www.instagram.com/weprodigi_agency/"
                        >
                          <span className="instagram"></span>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a
                          className="social-icon"
                          href="https://www.linkedin.com/company/weprodigiagency/"
                        >
                          <span className="linkedin"></span>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a
                          className="social-icon"
                          href="https://www.youtube.com/channel/UC6mkepDFKswxQWS76hgOMBg"
                        >
                          <span className="youtube"></span>
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a
                          className="social-icon"
                          href="https://x.com/WeProdigi"
                        >
                          <span className="x"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                ) : null}
              </div>
            </div>

            {/* Mobile menu end */}
          </nav>
        </div>
        <Proposal
          country={this.props.country}
          show={this.state.showOfferModal}
          hide={this.hideModal}
          submit={this.onSubmit}
        ></Proposal>
      </>
    );
  }
}

export default Navbar;
